export default __webpack_public_path__ + "static/media/19_mobile.057b215d.jpg";